module.exports = __webpack_public_path__ + "img/iphone2.faa74fc7.png";